import { ArrowUpRight } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { useSite } from "../context/SiteContext";
import { GALLERY_PHOTOS, track } from "../lib/site";

const RITUALS = [
  { name: "Abhyanga Warm-Oil Ritual", detail: "A classical Ayurvedic full-body massage with herbal oils, finished with a steam towel wrap.", time: "60 / 90 min" },
  { name: "Hot-Stone Journey", detail: "Volcanic basalt stones trace the spine and shoulders, melting deep muscular tension.", time: "75 min" },
  { name: "Madhubhan Signature Facial", detail: "Sandalwood, saffron and rose — a brightening ritual for sun-warmed skin.", time: "60 min" },
  { name: "Couples' Reverie", detail: "A private suite, two therapists, and a shared hour that slows everything down.", time: "90 min" },
  { name: "Hydrotherapy Soak", detail: "Mineral soak and rain-shower sequence to reset circulation and sleep.", time: "45 min" },
];

export default function Spa() {
  const { openBooking } = useSite();
  return (
    <main>
      <PageHero
        image={GALLERY_PHOTOS[2]}
        eyebrow="Resort & Spa"
        lines={[<>Restore</>, <em>your rhythm.</em>]}
        lede="The Sutra Spa pairs Ayurvedic tradition with quiet, contemporary comfort — warm oils, hot stones and unhurried hands."
      />
      <section className="section-pad intro" data-testid="spa-rituals">
        <Reveal className="section-kicker">The ritual menu</Reveal>
        <div className="intro-copy">
          <Reveal><h2>Hands that<br /><em>unhurriedly heal.</em></h2></Reveal>
          <Reveal delay={0.12}><p>Open daily 9 AM to 8 PM for resident and visiting guests. Reserve ahead and our therapists will prepare the suite, the oils and the silence.</p></Reveal>
        </div>
        <div className="ritual-list">
          {RITUALS.map((ritual, i) => (
            <Reveal key={ritual.name} delay={i * 0.06} className="ritual-row" data-testid={`ritual-${i}`}>
              <span className="ritual-num">{String(i + 1).padStart(2, "0")}</span>
              <div><h3>{ritual.name}</h3><p>{ritual.detail}</p></div>
              <span className="ritual-time">{ritual.time}</span>
            </Reveal>
          ))}
        </div>
        <Reveal className="center-row">
          <button className="gold-button" onClick={() => { track("book_now_click", { location: "spa_page" }); openBooking({}); }} data-testid="spa-book-button">
            Reserve a spa stay <ArrowUpRight size={16} />
          </button>
        </Reveal>
      </section>
      <Marquee />
      <section className="section-pad stay-section" data-testid="resort-amenities">
        <div className="section-heading">
          <Reveal><div><span className="eyebrow">Around the resort</span><h2>Everything else,<br /><em>taken care of.</em></h2></div></Reveal>
          <Reveal delay={0.1}><p>The spa is only the beginning. The estate holds quiet corners and lively ones in equal measure.</p></Reveal>
        </div>
        <Reveal className="intro-stats">
          <div><strong>01</strong><span>Temperature-controlled<br />infinity pool</span></div>
          <div><strong>02</strong><span>Indoor & outdoor<br />games pavilion</span></div>
          <div><strong>03</strong><span>Gardens, lawns<br />& birding groves</span></div>
          <div><strong>04</strong><span>Gym & yoga<br />lawn at dawn</span></div>
        </Reveal>
      </section>
    </main>
  );
}
